<template>
  
  <div class="">
    <div class="caseVideo">
      <div class="bannerTemp">
        <!-- <bannerTemp :data="bannerData"></bannerTemp> -->
      </div>
      <div class="body-wrapper">
        <iframe
          src="http://47.92.199.181:8953/ztmapvideo/#/"
          width="100%"
          height="100%"
          frameborder="0"
        ></iframe>
      </div>
    </div>
    <div class="mobile-caseVideo">
      <div class="mobile-bannerTemp">
        <!-- <bannerTemp :data="bannerData" :isLong="true"></bannerTemp> -->
      </div>
      <div class="case-container">
        <iframe
          src="http://47.92.199.181:8953/ztmapvideo/#/"
          width="100%"
          height="100%"
          frameborder="0"
        ></iframe>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CaseVideo',
  metaInfo: {
    title: '三维GIS可视化渲染应用成功案例-上海臻图信息技术有限公司',
    meta: [
      {
        name: 'keywords',
        content:
          '三维GIS可视化,三维GIS渲染,GIS地理信息,三维应用案例,GIS+BIM案例,VR三维全景案例'
      },
      {
        name: 'description',
        content:
          '智慧城市和物联网行业内专业数字孪生时空大数据可视化典型成功案例,包含政府、企业、事业、互联网等各个行业项目案例。'
      }
    ]
  },
  data () {
    return {
      bannerData: {
        title: '经典案例',
        p:
          '臻图信息依托多年的产品研发和项目实施经验，建立了完备的软件系统设计咨询服务体系，力争成为业内服务最好的智慧城市信息可视化服务企业。'
      },
      page: 1
    }
  },
  mounted: function () {}
}
</script>
<style lang="less" scoped>
.bannerTemp {
  height: 70px;
  background-image: url("../assets/images/case/banner.jpg");
  background-position: bottom;
}
.body-wrapper {
  height: 700px;
}
.caseVideo {
}
.mobile-caseVideo {
  display: none;
  width: 100%;
  flex-direction: column;
  font-family: 'Normal';
  .mobile-bannerTemp {
    width: 100%;
    background-image: url("../assets/images/case/banner.jpg");
    background-position: 30%;
    background-size: cover;
    height: 5rem;
  }
  .case-container {
    width: 100%;
    height:55rem;
  }
}
@media (max-width: 1024px) {
  .caseVideo {
    display: none !important;
  }
  .bannerTemp {
    display: none !important;
  }
  .mobile-caseVideo { 
    display: flex !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/caseVideo.vue